import { Box, Button, Container, Snackbar, IconButton, Grid, TextField, Typography, MenuItem, useMediaQuery, useTheme } from '@mui/material'

import { QRCodeCanvas } from 'qrcode.react'
import React, { useState } from 'react'
// import QRCode from 'react-qr-code'
import { Form, FormikProvider, useFormik } from 'formik';
import * as yup from 'yup';
import CloseIcon from "@mui/icons-material/Close";


export default function App() {



  // const [textForm, setTextForm] = useState({
  //   consignee: '',
  //   tel: '',
  //   teltwo: '',
  //   country: '',
  //   province: '',
  //   city: '',
  //   district: '',
  //   road: '',
  //   remark: '',
  // })

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setTextForm(e => {
  //     return {
  //       ...e,
  //       [name]: value
  //     }
  //   })
  // }
  // const handleGenQR = () => {
  //   const alladdress = formik.values.consignee + '|' + formik.values.tel + '|' + formik.values.teltwo + '|' + formik.values.country + '|' + formik.values.province + '|' + formik.values.city + '|' + formik.values.district + '|' + formik.values.road + '|' + formik.values.remark;
  //   setTextQR(alladdress)
  // }

  const [textQR, setTextQR] = useState(localStorage.getItem("textQR") || null)
  const [open, setOpen] = useState(false);
  // const textQR = localStorage.getItem("textQR")





  const formSchema = yup.object().shape({
    consignee: yup.string().required('Consignee required'),
    tel: yup.string().required('Telephone required'),
    teltwo: yup.string().notRequired(),
    email: yup.string().email("Must be a valid email").notRequired(),
    country: yup.string().required('Country required'),
    address: yup.string().required('Address required'),
    // province: yup.string().required('Province required'),
    // city: yup.string().required('City required'),
    // district: yup.string().required('District required'),
    // road: yup.string().required('Road required'),
    zipcode: yup.string().required('Zipcode required'),
    remark: yup.string().notRequired(),
  });
  const formik = useFormik({
    initialValues: {
      consignee: '',
      tel: '',
      teltwo: '',
      email: '',
      country: '',
      address: '',
      province: '',
      city: '',
      district: '',
      road: '',
      zipcode: '',
      remark: '',
    },
    validationSchema: formSchema,
    onSubmit: (values) => {
      // const alladdress = values.consignee + '|' + values.tel + '|' + values.teltwo + '|' + values.country + '|' + values.province + '|' + values.city + '|' + values.district + '|' + values.road + '|' + values.remark;
      setTextQR(JSON.stringify(values))
      localStorage.setItem("textQR", JSON.stringify(values))
      // var usrlang = navigator.languages;
      // console.log(usrlang);
    },
  });


  const country = [
    {
      value: 'AUSTRALIA',
      label: 'AUSTRALIA',
    },
    {
      value: 'CHINA',
      label: 'CHINA',
    },
    {
      value: 'RUSSIAN FEDERATION',
      label: 'RUSSIAN FEDERATION',
    },
    {
      value: 'THAILAND',
      label: 'THAILAND',
    },
    {
      value: 'TAIWAN',
      label: 'TAIWAN',
    },
    {
      value: 'AMERICA',
      label: 'AMERICA',
    },
    {
      value: 'VIETNAM',
      label: 'VIETNAM',
    },
    {
      value: 'CANADA',
      label: 'CANADA',
    },
    {
      value: 'GERMANY',
      label: 'GERMANY',
    },
    {
      value: 'JAPAN',
      label: 'JAPAN',
    },
    {
      value: 'KOREA',
      label: 'KOREA',
    },
    {
      value: 'POLAND',
      label: 'POLAND',
    },
    {
      value: 'NETHERLANDS',
      label: 'NETHERLANDS',
    },
    {
      value: 'NEW ZEALAND',
      label: 'NEW ZEALAND',
    },
    {
      value: 'UNITEDKINGDOM',
      label: 'UNITEDKINGDOM',
    },
    {
      value: 'BELGIUM',
      label: 'BELGIUM',
    },
    {
      value: 'HONGKONG',
      label: 'HONGKONG',
    },
    {
      value: 'FRANCE',
      label: 'FRANCE',
    },
    {
      value: 'NORWAY',
      label: 'NORWAY',
    },
    {
      value: 'SWITZERLAND',
      label: 'SWITZERLAND',
    },
    {
      value: 'MALAYSIA',
      label: 'MALAYSIA',
    },
    {
      value: 'SINGAPORE',
      label: 'SINGAPORE',
    },
    {
      value: 'AUSTRIA',
      label: 'AUSTRIA',
    },
    {
      value: 'INDONESIA',
      label: 'INDONESIA',
    },
    {
      value: 'INDIA',
      label: 'INDIA',
    },
    {
      value: 'IRELAND',
      label: 'IRELAND',
    },
    {
      value: 'ICELAND',
      label: 'ICELAND',
    },
    {
      value: 'ITALY',
      label: 'ITALY',
    },
    {
      value: 'CAMBODIA',
      label: 'CAMBODIA',
    },
    {
      value: 'LAOS',
      label: 'LAOS',
    },
    {
      value: 'MYANMAR',
      label: 'MYANMAR',
    }

  ];
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));


  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };


  return (
    <Container maxWidth="sm">
      {
        textQR !== null && (
          <Grid
            container
            spacing={2}
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              color: "#906C4E"
            }}
          >
            <Grid item xs={12} sx={{
              textAlign: "center",
              margin: "10px"
            }} >
              <Typography variant="h5" >Thank you for purchase</Typography>
            </Grid>
            <Grid item xs={12} sx={{
              textAlign: "center",
              margin: "20px"
            }} >
              {/* {textQR} */}
              <QRCodeCanvas value={textQR} size={isMobile ? 300 : 300} />
            </Grid>
            <Grid item xs={12} sx={{
              textAlign: "center",

              margin: "20px"
            }} >
              <Typography variant="h5" >
                {
                  // "Country : " + formik.values.country
                  // formik.values.country
                  JSON.parse(textQR).country
                }
              </Typography>
            </Grid>
            <Box textAlign='center'
              sx={{
                margin: "20px"
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  // localStorage.clear()
                  formik.resetForm({
                    values: JSON.parse(textQR)
                  })
                  setTextQR(null)
                }}
              >
                back
              </Button>
            </Box>
          </Grid>
        )
      }
      {
        textQR === null && (
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
              <Grid
                container
                spacing={2}
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{
                  color: "#906C4E"
                }}
              >
                <Grid item xs={12} sx={{
                  textAlign: "center",
                  margin: "10px"
                }} >
                  <Typography variant="h5" >Thank you for purchase</Typography>
                </Grid>
                <Grid item xs={4} >
                  Consignee <br />
                  收货人名字
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.consignee && Boolean(formik.errors.consignee)}
                    helperText={formik.touched.consignee && formik.errors.consignee}
                    name="consignee"
                    value={formik.values.consignee}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4} >
                  Telephone Number <br />
                  电话号码
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.tel && Boolean(formik.errors.tel)}
                    helperText={formik.touched.tel && formik.errors.tel}
                    name="tel"
                    value={formik.values.tel}
                    type="tel"
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4} >
                  <br />

                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.teltwo && Boolean(formik.errors.teltwo)}
                    helperText={formik.touched.teltwo && formik.errors.teltwo}
                    name="teltwo"
                    type="tel"
                    value={formik.values.teltwo}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={4} >
                  Email <br />
                  电子邮件
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                    name="email"
                    value={formik.values.email}
                    type="email"
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} alignContent="center" sx={{
                  textAlign: "center"
                }} >
                  Address information <br />
                  地址信息
                </Grid>

                <Grid item xs={4} >
                  Country <br />
                  国家
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.country && Boolean(formik.errors.country)}
                    helperText={formik.touched.country && formik.errors.country}
                    name="country"
                    value={formik.values.country}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                    select
                  >
                    {country.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>

                </Grid>
                <Grid item xs={4} >
                  Address <br />
                  地址
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
                    name="address"
                    value={formik.values.address}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    rows={3}
                  />

                </Grid>
                {/*
                <Grid item xs={4} >
                  Province <br />
                  省
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.province && Boolean(formik.errors.province)}
                    helperText={formik.touched.province && formik.errors.province}
                    name="province"
                    value={formik.values.province}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                </Grid>

                <Grid item xs={4} >
                  City <br />
                  市
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={formik.touched.city && formik.errors.city}
                    name="city"
                    value={formik.values.city}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                </Grid>

                <Grid item xs={4} >
                  District <br />
                  区（县）
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.district && Boolean(formik.errors.district)}
                    helperText={formik.touched.district && formik.errors.district}
                    name="district"
                    value={formik.values.district}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                </Grid>

                <Grid item xs={4} >
                  Road <br />
                  镇（街道）
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.road && Boolean(formik.errors.road)}
                    helperText={formik.touched.road && formik.errors.road}
                    name="road"
                    value={formik.values.road}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                </Grid>
                */}
                <Grid item xs={4} >
                  Zip code <br />
                  邮政编码
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.zipcode && Boolean(formik.errors.zipcode)}
                    helperText={formik.touched.zipcode && formik.errors.zipcode}
                    name="zipcode"
                    value={formik.values.zipcode}
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    size="small"
                    fullWidth
                  />

                </Grid>

                <Grid item xs={4} >
                  Remark <br />
                  备注
                </Grid>
                <Grid item xs={8} >
                  <TextField
                    onChange={formik.handleChange}
                    error={formik.touched.remark && Boolean(formik.errors.remark)}
                    helperText={formik.touched.remark && formik.errors.remark}
                    name="remark"
                    value={formik.values.remark}
                    id="outlined-basic"
                    label="" variant="outlined"
                    size="small"
                    multiline
                    rows={4}
                    // maxRows={4}
                    fullWidth />

                </Grid>

                <Box textAlign='center'
                  sx={{
                    margin: "20px",
                    justifyContent: "space-around",
                    display: "flex",
                  }}
                >
                  <Button
                    variant="contained"
                    // onClick={handleGenQR}
                    type="submit"
                  >
                    QR Code
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    type="button"
                    sx={{
                      marginLeft: "20px"
                    }}
                    onClick={handleClick}
                  >
                    reset
                  </Button>
                </Box>

              </Grid>
            </Form>
          </FormikProvider>
        )
      }


      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message="Do you want to reset?"
        // direction="up"
        action={
          <React.Fragment>
            <Button color="success" size="small" onClick={
              () => {
                setTextQR(null)
                localStorage.clear()
                formik.resetForm({
                  values: {
                    consignee: '',
                    tel: '',
                    teltwo: '',
                    email: '',
                    country: '',
                    address: '',
                    province: '',
                    city: '',
                    district: '',
                    road: '',
                    zipcode: '',
                    remark: '',
                  }
                })
                setOpen(false)
              }
            }>
              YES
            </Button>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
    </Container >
  )
}
